import {
  ChartAreaContainer,
  PortfolioContentWrapper,
  PortfolioTitle,
  SelectDropdownWrapper,
} from './styled'

import React from 'react'
import { SelectBoxDropdown } from './components/product-selection'
import { ALL_PORTFOLIO_ID } from 'app-constants'
import { onlyProductsWithHistory } from './services'
import { PortfolioPageProps } from './interface'
import PortfolioComposition from './components/composition'
import { IndexDetails } from './components/portfolio-chart'
import PortfolioLoading from './loading'

export const PortfolioPage: React.FC<PortfolioPageProps> = ({ portfolioStorage }) => {
  return portfolioStorage.chartData === null ? (
    <PortfolioLoading />
  ) : (
    <PortfolioContentWrapper>
      <PortfolioTitle>Portfolio</PortfolioTitle>
      <ChartAreaContainer>
        <SelectDropdownWrapper>
          <SelectBoxDropdown
            dispatch={portfolioStorage.dispatch}
            productHistory={portfolioStorage.userProductHistory
              .filter(onlyProductsWithHistory)
              .filter((el) => !portfolioStorage.errorProducts.includes(el.id))}
          />
        </SelectDropdownWrapper>
        <IndexDetails portfolioStorage={portfolioStorage} />
      </ChartAreaContainer>
      {portfolioStorage.selectedProductId === ALL_PORTFOLIO_ID && (
        <PortfolioComposition portfolioStorage={portfolioStorage} />
      )}
    </PortfolioContentWrapper>
  )
}

export default PortfolioPage
